<template>
  <div class="scrollGameCatesList">
    <ScrollList class="gameCatesList" v-if="list.length">
    <div class="catItem" @click="gotoGameCategory(item, $router)"  v-for="(item, index) in list" :key="index">
      <Image
        class="size-11 object-cover mx-auto mt-1"
        :src="item.customIcon || item.defaultIcon || item.icon">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </Image>
      <span class="txt">
        {{ item.customName || item.name }}
      </span>
    </div>
    
    <template #arrowLeft>
      <span class="arrow rotate-180"></span>
    </template>

    <template #arrowRight>
      <span class="arrow"></span>
    </template>
    
    </ScrollList>
  </div>
</template>

<script setup lang="ts">
  import { useGameCategory } from '@/store'
  import ScrollList from '@a/components/ScrollList/index.vue'
  import { gotoGameCategory } from '@/utils'

  const list = computed(() => useGameCategory().topList)
</script>

<style lang="scss" scoped>
.scrollGameCatesList {
  @apply sticky top-[calc(52px+var(--topInstallBar-height)+var(--safe-top))] z-[99] bgs-[url('@/themes/theme_a/assets/images/bg.png')] bg-fixed bg-[var(--theme-primary-dark)];

  .gameCatesList {
    @apply flex overflow-x-auto overflow-y-hidden snap-x snap-mandatory p-[8px_12px] ;

    .catItem {
      @apply wh-[48px_68px] flex-center-col-x shrink-0 mr-7 last:mr-0 snap-start;
    }

    .txt {
      @apply leading-4 whitespace-nowrap text-clip text-[#FFD53E] mt-1.5 font-[700] text-11;
    }
  }

  .arrow{
    @apply w-4 h-full bgs-[url('@a/views/Home/images/i_arrow_r.png'),center_center,12px] block;
  }
}

</style>
